import { connect } from 'react-redux';
import LaporanGuruD4S1 from '../../../views/Akademi/LaporanIndividual/LaporanGuruD4S1.view';
import { getParamOptionsAcademics, getPrmLevels } from '../../../states/thunks/options.thunk';
import { listReportGuruD4S1, getHeadmaster, listReportGuruS3, listReportGuruBelumSertifikat } from '../../../states/thunks/academics.thunk';
function mapStateToProps(state){
    return{
        user: state.user,
        result: state.result,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
        handleListReportGuruD4S1: (payload) => dispatch(listReportGuruD4S1(payload)),
        getPrmLevels: (payload) => dispatch(getPrmLevels(payload)),
        getHeadmaster: (payload) => dispatch(getHeadmaster(payload)),
        handleListReportGuruS3: (payload) => dispatch(listReportGuruS3(payload)),
        handleListReportGuruBelumSertifikat: (payload) => dispatch(listReportGuruBelumSertifikat(payload)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LaporanGuruD4S1);